import React from 'react';
import { Link } from 'react-router-dom';
import { getAboutPath, getTermsPath, getPrivacyPath } from '@/utils/localePaths';
import { getStoredLanguage } from '@/config/languages';

/**
 * Footer Component - Global Minimalist Design
 * 
 * ALWAYS IN ENGLISH - Same across ALL pages
 * Links are UNIVERSAL - always point to /about, /terms, /privacy (no locale prefix)
 * Fixed height, always at the bottom of viewport
 */
function Footer() {
  return (
    <footer className="w-full border-t border-gray-800/50 bg-black mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Single row layout */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
          
          {/* Left - Copyright */}
          <div className="text-gray-300 order-2 sm:order-1">
            © 2026 OPARA. All rights reserved.
          </div>
          
          {/* Center - Navigation Links - UNIVERSAL (no locale prefix) */}
          <div className="flex items-center gap-3 order-1 sm:order-2">
            <Link
              to={getAboutPath(getStoredLanguage())}
              className="text-gray-300 hover:text-white transition-colors"
            >
              About
            </Link>
            <span className="text-gray-500">•</span>
            <Link
              to={getTermsPath(getStoredLanguage())}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Terms & Service
            </Link>
            <span className="text-gray-500">•</span>
            <Link
              to={getPrivacyPath(getStoredLanguage())}
              className="text-gray-300 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
          
          {/* Right - Support Email */}
          <a 
            href="mailto:support@opara.co"
            className="text-gray-300 hover:text-white transition-colors order-3"
          >
            support@opara.co
          </a>
          
        </div>
      </div>
    </footer>
  );
}

export default Footer;
